import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import fastDeepEqual from '../../../../fast-deep-equal/4c5cbd71d86f8cf8240b57a972397ac30e65f341ab11e45b1172e7c78722f535.cfe-internal.js';
import { useState, useCallback } from 'react';
import { useIsomorphicLayoutEffect } from './e6bd8d9d193665651547f77cb2adacf0dae81d061654707a931bdfc0fd619642.cfe-internal.js';

/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */
function useCollector(monitor, collect, onUpdate) {
  var _useState = useState(function () {
      return collect(monitor);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    collected = _useState2[0],
    setCollected = _useState2[1];
  var updateCollected = useCallback(function () {
    var nextValue = collect(monitor);
    // This needs to be a deep-equality check because some monitor-collected values
    // include XYCoord objects that may be equivalent, but do not have instance equality.
    if (!fastDeepEqual(collected, nextValue)) {
      setCollected(nextValue);
      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]);
  // update the collected properties after react renders.
  // Note that the "Dustbin Stress Test" fails if this is not
  // done when the component updates
  useIsomorphicLayoutEffect(updateCollected);
  return [collected, updateCollected];
}

export { useCollector };
